import ApiCore from './api-core'
import { ACTIVE_BASE_REST } from './constants'
export default class Geo extends ApiCore {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/geo`)
  }

  provinces(filter) {
    return this._request({
      action: 'province/list',
      method: 'GET',
      params: filter
    })
  }

  extractProvince(filter) {
    return this._request({
      action: 'province/extract',
      method: 'GET',
      params: filter
    })
  }

  cityByProvince(filter) {
    return this._request({
      action: 'city/list',
      method: 'GET',
      params: filter
    })
  }

  extractCity(filter) {
    return this._request({
      action: 'city/extract',
      method: 'GET',
      params: filter
    })
  }

  cityList(filter, showProgress) {
    return this._request({
      action: 'city/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  trafficPlanList(filter) {
    return this._request({
      action: 'trafficPlan/list',
      method: 'GET',
      params: filter
    })
  }

  extractTrafficPlan(filter) {
    return this._request({
      action: 'trafficPlan/extract',
      method: 'GET',
      params: filter
    })
  }

  frequentCities(filter, showProgress) {
    return this._request({
      action: 'city/frequent/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
